import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex flex-wrap gap-3" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "space-y-6 rounded-lg bg-white p-4 shadow sm:p-6" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "min-w-0 flex-1 space-y-1" }
const _hoisted_8 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_9 = { class: "truncate text-sm font-semibold text-gray-900" }
const _hoisted_10 = { class: "flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_14 = ["datetime"]

import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import {
    CalendarIcon,
    ChevronRightIcon,
    ExternalLinkIcon,
    PhoneIcon,
    UsersIcon,
} from '@heroicons/vue/solid';
import { MetaIntegrationService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { MetaWaba, MetaWhatsAppNumberPolicy, WhatsAppWabaStatusColorMap } from '@/types';
import { formatDateAsString } from '@/utils/datetime';
import { attendanceUrl } from '@/configs';
import { operatingPhoneCount, wabaStatus } from '@/utils/whatsappMeta';
import CompanyPhoneQuotaSummary from './components/CompanyPhoneQuotaSummary.vue';
import WhatsAppMetaHeader from './components/WhatsAppMetaHeader.vue';

const perPage = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaListPage',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const wabas = ref<MetaWaba[]>([]);
const policy = ref<MetaWhatsAppNumberPolicy | null>(null);
const currentPage = ref(1);
const paginatedWabas = computed(() => {
    const start = (currentPage.value - 1) * perPage;
    return wabas.value.slice(start, start + perPage);
});

const openWaba = (wabaId: string) => {
    router.push({ name: 'WhatsAppMetaDetail', params: { wabaId } });
};

const loadPolicy = async () => {
    try {
        policy.value = (await MetaIntegrationService.getWhatsAppNumberPolicy()).data;
    } catch {
        policy.value = null;
    }
};

const load = async () => {
    loadPolicy();
    try {
        const { data } = await MetaIntegrationService.getWabas();
        wabas.value = data;
    } catch (error) {
        toastServiceError(error);
    }
};

onMounted(load);

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiSettingsRow = _resolveComponent("UiSettingsRow")!
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiSettingsSection = _resolveComponent("UiSettingsSection")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UiButton, {
        variant: "white",
        "text-variant": "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Integration' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.list.back')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_unref(attendanceUrl))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "text-primary flex items-center justify-center rounded bg-white px-3 py-2 text-sm font-medium shadow ring-1 ring-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50",
              href: _unref(attendanceUrl),
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.list.openAttendance')) + " ", 1),
              _createVNode(_unref(ExternalLinkIcon), {
                class: "ml-2 h-4 w-4",
                "aria-hidden": "true"
              })
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createVNode(_component_UiButton, {
          variant: "primary",
          "text-variant": "white",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'ConnectWhatsAppMeta' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.list.connect')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(WhatsAppMetaHeader, {
        title: _unref(t)('whatsappMeta.list.title'),
        subtitle: _unref(t)('whatsappMeta.list.subtitle'),
        summary: _unref(t)('whatsappMeta.list.accountCount', wabas.value.length)
      }, null, 8, ["title", "subtitle", "summary"]),
      (wabas.value.length && policy.value)
        ? (_openBlock(), _createBlock(CompanyPhoneQuotaSummary, {
            key: 0,
            used: policy.value.used,
            limit: policy.value.limit,
            full: policy.value.full
          }, null, 8, ["used", "limit", "full"]))
        : _createCommentVNode("", true),
      _createVNode(_component_UiSettingsSection, {
        title: _unref(t)('whatsappMeta.list.accounts')
      }, {
        default: _withCtx(() => [
          (wabas.value.length === 0)
            ? (_openBlock(), _createBlock(_component_UiSettingsRow, {
                key: 0,
                title: _unref(t)('whatsappMeta.list.emptyTitle'),
                description: _unref(t)('whatsappMeta.list.empty')
              }, null, 8, ["title", "description"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedWabas.value, (waba) => {
            return (_openBlock(), _createElementBlock("button", {
              key: waba.wabaId,
              type: "button",
              class: "focus-visible:ring-primary flex min-h-[52px] w-full items-center gap-3 p-4 text-left hover:bg-gray-50/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset",
              onClick: ($event: any) => (openWaba(waba.wabaId))
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(waba.displayName || waba.wabaId), 1),
                  _createVNode(_component_UiBadge, {
                    variant: _unref(WhatsAppWabaStatusColorMap)[_unref(wabaStatus)(waba)],
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(`whatsappMeta.list.status.${_unref(wabaStatus)(waba)}`)), 1)
                    ]),
                    _: 2
                  }, 1032, ["variant"])
                ]),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_unref(PhoneIcon), {
                      class: "mr-1 h-4 w-4 flex-none text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(t)(
                                        'whatsappMeta.list.operatingPhoneNumbers',
                                        _unref(operatingPhoneCount)(waba),
                                    )), 1)
                  ]),
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_unref(UsersIcon), {
                      class: "mr-1 h-4 w-4 flex-none text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString(waba.createdByUser?.name || _unref(t)('whatsappMeta.list.unknownUser')), 1)
                  ]),
                  (waba.createdAt)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        _createVNode(_unref(CalendarIcon), {
                          class: "mr-1 h-4 w-4 flex-none text-gray-400",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("time", {
                          datetime: waba.createdAt
                        }, _toDisplayString(_unref(formatDateAsString)(waba.createdAt, 'LL')), 9, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_unref(ChevronRightIcon), {
                class: "h-5 w-5 flex-none text-gray-400",
                "aria-hidden": "true"
              })
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _: 1
      }, 8, ["title"]),
      (wabas.value.length)
        ? (_openBlock(), _createBlock(_component_UiPagination, {
            key: 1,
            modelValue: currentPage.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
            count: wabas.value.length,
            "per-page": perPage
          }, null, 8, ["modelValue", "count"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})